module.exports = "<div class=\"lui-typeahead__wrapper lui-suggestions__menu-wrapper\">\n  <lui-textfield></lui-textfield>\n  <span class=\"lui-suggestions__menu-placeholder\"></span>\n  <slot></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-typeahead/theme/lui-typeahead.html
// module id = 365
// module chunks = 0 1 20